import type { PropsWithChildren } from "react";

import { createPortal } from "react-dom";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@alaffia-technology-solutions/ds";
import { useQuerySelector } from "@alaffia-technology-solutions/hooks";

interface PDFTextSelectionTooltipProps extends PropsWithChildren {
  open?: boolean;
  onClose?: () => unknown;
  containerQuerySelector?: string;
}

export function PDFTextSelectionTooltip({
  open,
  onClose,
  containerQuerySelector = "mark.fv__mark-selection-blank",
  children,
}: PDFTextSelectionTooltipProps) {
  const container = useQuerySelector(containerQuerySelector, {
    enabled: open,
  });

  if (!container) {
    return null;
  }

  return (
    <Popover
      open={open}
      onOpenChange={(openState) => {
        if (!openState && onClose) {
          onClose();
        }
      }}
    >
      {createPortal(
        // Foxit SDK has a CSS selector overwriting styles of button elements inside the .fv__mark-selection-blank,
        // so we need to render PopoverTrigger as other tag (for example div).
        <PopoverTrigger className="af-h-full" asChild>
          <div />
        </PopoverTrigger>,
        container,
      )}
      <PopoverContent
        className="af-w-fit af-rounded-lg af-border af-border-interface-border af-bg-card af-p-1.5 af-shadow-[0px_25px_25px_rgba(42,100,246,0.1)]"
        side="top"
        hideWhenDetached
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
